import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-print-transunion-table',
  templateUrl: './print-transunion-table.component.html',
  styleUrls: ['./print-transunion-table.component.scss']
})
export class PrintTransunionTableComponent {
    @Input() dataSource: any;
}
